// App-approved artwork and badge mapping. Lucide icon geometry is ISC licensed.
export const profileMarkData = {
  tiers: {
    goal_first: 1,
    goal_three_months: 2,
    goal_week_streak_4: 2,
    goal_six_months: 3,
    goal_week_streak_12: 3,
    ratings_10: 1,
    reviews_first: 1,
    reviews_25: 2,
    ratings_50: 2,
    ratings_100: 3,
    reviews_50: 3,
    track_ratings_25: 2,
    decades_5: 1,
    genres_10: 2,
    decades_8: 3,
    genres_20: 3,
    members_explored_10: 1,
    members_explored_30: 2,
    members_explored_100: 3,
    saves_10: 1,
    saves_50: 2,
    discoveries_25: 1,
    discoveries_100: 2,
    shares_first: 1,
    shares_3: 2,
    shares_20: 3,
    mastery_1: 1,
    mastery_2: 2,
    mastery_3: 3,
    playlist_5: 1,
    curator_3: 2,
    playlist_20: 2,
    curator_10: 3,
    community_days_5: 1,
    community_days_3: 1,
    following_5: 1,
    following_20: 2,
    reactions_10: 2,
    community_days_30: 3,
    reactions_50: 3,
    reactions_25: 3,
    streak_3: 1,
    streak_7: 2,
    streak_14: 2,
    streak_30: 3,
    active_weeks_4: 2,
    active_weeks_12: 3,
    badges_5: 1,
    badges_15: 2,
    badges_25: 3,
    season_participant: 1,
    hidden_pathfinder: 2,
  },
  maps: {
    key: {
      goal_first: 'Target',
      goal_three_months: 'CalendarDays',
      goal_week_streak_4: 'CalendarCheck',
      goal_six_months: 'Trophy',
      goal_week_streak_12: 'CalendarHeart',
      ratings_10: 'Disc3',
      reviews_first: 'NotebookPen',
      reviews_25: 'BookOpen',
      ratings_50: 'Library',
      ratings_100: 'Ear',
      reviews_50: 'NotebookPen',
      track_ratings_25: 'Music2',
      decades_5: 'Compass',
      genres_10: 'Shapes',
      decades_8: 'MapIcon',
      genres_20: 'Orbit',
      members_explored_10: 'UsersRound',
      members_explored_30: 'UsersRound',
      members_explored_100: 'MapIcon',
      saves_10: 'Bookmark',
      saves_50: 'Library',
      discoveries_25: 'Search',
      discoveries_100: 'Compass',
      shares_first: 'Share2',
      shares_3: 'Send',
      shares_20: 'Mail',
      mastery_1: 'Sparkles',
      mastery_2: 'Gem',
      mastery_3: 'Crown',
      playlist_5: 'ListMusic',
      curator_3: 'WandSparkles',
      playlist_20: 'ListChecks',
      curator_10: 'Star',
      community_days_5: 'MessageCircle',
      community_days_3: 'MessageCircle',
      following_5: 'UserPlus',
      following_20: 'UsersRound',
      reactions_10: 'Heart',
      community_days_30: 'MessageCircleMore',
      reactions_50: 'UsersRound',
      reactions_25: 'UsersRound',
      streak_3: 'Flame',
      streak_7: 'CalendarClock',
      streak_14: 'BadgeCheck',
      streak_30: 'Award',
      active_weeks_4: 'CalendarCheck',
      active_weeks_12: 'CalendarRange',
      badges_5: 'Medal',
      badges_15: 'Gem',
      badges_25: 'Crown',
      season_participant: 'Sparkles',
      hidden_pathfinder: 'Footprints',
    },
    iconKey: {
      award: 'Award',
      'book-open': 'BookOpen',
      'calendar-check': 'CalendarCheck',
      compass: 'Compass',
      disc: 'Disc3',
      flame: 'Flame',
      heart: 'Heart',
      library: 'Library',
      'list-checks': 'ListChecks',
      'list-music': 'ListMusic',
      list: 'ListMusic',
      map: 'MapIcon',
      medal: 'Medal',
      'message-circle': 'MessageCircle',
      mail: 'Mail',
      gem: 'Gem',
      crown: 'Crown',
      send: 'Send',
      'share-2': 'Share2',
      sparkles: 'Sparkles',
      target: 'Target',
      trophy: 'Trophy',
    },
    category: {
      GOALS: 'Target',
      RECORDING: 'Disc3',
      EXPLORATION: 'Compass',
      DISCOVERY: 'Search',
      SHARING: 'Share2',
      CURATION: 'ListMusic',
      COMMUNITY: 'MessagesSquare',
      STREAK: 'Flame',
      MASTERY: 'Crown',
      COLLECTION: 'Medal',
      SEASONAL: 'Sparkles',
    },
  },
  icons: {
    Target: [
      ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
      ['circle', { cx: '12', cy: '12', r: '6', key: '1vlfrh' }],
      ['circle', { cx: '12', cy: '12', r: '2', key: '1c9p78' }],
    ],
    CalendarDays: [
      ['path', { d: 'M8 2v4', key: '1cmpym' }],
      ['path', { d: 'M16 2v4', key: '4m81vk' }],
      ['rect', { width: '18', height: '18', x: '3', y: '4', rx: '2', key: '1hopcy' }],
      ['path', { d: 'M3 10h18', key: '8toen8' }],
      ['path', { d: 'M8 14h.01', key: '6423bh' }],
      ['path', { d: 'M12 14h.01', key: '1etili' }],
      ['path', { d: 'M16 14h.01', key: '1gbofw' }],
      ['path', { d: 'M8 18h.01', key: 'lrp35t' }],
      ['path', { d: 'M12 18h.01', key: 'mhygvu' }],
      ['path', { d: 'M16 18h.01', key: 'kzsmim' }],
    ],
    CalendarCheck: [
      ['path', { d: 'M8 2v4', key: '1cmpym' }],
      ['path', { d: 'M16 2v4', key: '4m81vk' }],
      ['rect', { width: '18', height: '18', x: '3', y: '4', rx: '2', key: '1hopcy' }],
      ['path', { d: 'M3 10h18', key: '8toen8' }],
      ['path', { d: 'm9 16 2 2 4-4', key: '19s6y9' }],
    ],
    Trophy: [
      ['path', { d: 'M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978', key: '1n3hpd' }],
      ['path', { d: 'M14 14.66v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978', key: 'rfe1zi' }],
      ['path', { d: 'M18 9h1.5a1 1 0 0 0 0-5H18', key: '7xy6bh' }],
      ['path', { d: 'M4 22h16', key: '57wxv0' }],
      ['path', { d: 'M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z', key: '1mhfuq' }],
      ['path', { d: 'M6 9H4.5a1 1 0 0 1 0-5H6', key: 'tex48p' }],
    ],
    CalendarHeart: [
      [
        'path',
        { d: 'M12.127 22H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5.125', key: 'vxdnp4' },
      ],
      [
        'path',
        {
          d: 'M14.62 18.8A2.25 2.25 0 1 1 18 15.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z',
          key: '15cy7q',
        },
      ],
      ['path', { d: 'M16 2v4', key: '4m81vk' }],
      ['path', { d: 'M3 10h18', key: '8toen8' }],
      ['path', { d: 'M8 2v4', key: '1cmpym' }],
    ],
    Disc3: [
      ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
      ['path', { d: 'M6 12c0-1.7.7-3.2 1.8-4.2', key: 'oqkarx' }],
      ['circle', { cx: '12', cy: '12', r: '2', key: '1c9p78' }],
      ['path', { d: 'M18 12c0 1.7-.7 3.2-1.8 4.2', key: '1eah9h' }],
    ],
    NotebookPen: [
      [
        'path',
        { d: 'M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4', key: 're6nr2' },
      ],
      ['path', { d: 'M2 6h4', key: 'aawbzj' }],
      ['path', { d: 'M2 10h4', key: 'l0bgd4' }],
      ['path', { d: 'M2 14h4', key: '1gsvsf' }],
      ['path', { d: 'M2 18h4', key: '1bu2t1' }],
      [
        'path',
        {
          d: 'M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z',
          key: 'pqwjuv',
        },
      ],
    ],
    BookOpen: [
      ['path', { d: 'M12 7v14', key: '1akyts' }],
      [
        'path',
        {
          d: 'M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z',
          key: 'ruj8y',
        },
      ],
    ],
    Library: [
      ['path', { d: 'm16 6 4 14', key: 'ji33uf' }],
      ['path', { d: 'M12 6v14', key: '1n7gus' }],
      ['path', { d: 'M8 8v12', key: '1gg7y9' }],
      ['path', { d: 'M4 4v16', key: '6qkkli' }],
    ],
    Ear: [
      ['path', { d: 'M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0', key: '1dfaln' }],
      ['path', { d: 'M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4', key: '1qnva7' }],
    ],
    Music2: [
      ['circle', { cx: '8', cy: '18', r: '4', key: '1fc0mg' }],
      ['path', { d: 'M12 18V2l7 4', key: 'g04rme' }],
    ],
    Compass: [
      ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
      [
        'path',
        {
          d: 'm16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z',
          key: '9ktpf1',
        },
      ],
    ],
    Shapes: [
      [
        'path',
        {
          d: 'M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z',
          key: '1bo67w',
        },
      ],
      ['rect', { x: '3', y: '14', width: '7', height: '7', rx: '1', key: '1bkyp8' }],
      ['circle', { cx: '17.5', cy: '17.5', r: '3.5', key: 'w3z12y' }],
    ],
    MapIcon: [
      [
        'path',
        {
          d: 'M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z',
          key: '169xi5',
        },
      ],
      ['path', { d: 'M15 5.764v15', key: '1pn4in' }],
      ['path', { d: 'M9 3.236v15', key: '1uimfh' }],
    ],
    Orbit: [
      ['path', { d: 'M20.341 6.484A10 10 0 0 1 10.266 21.85', key: '1enhxb' }],
      ['path', { d: 'M3.659 17.516A10 10 0 0 1 13.74 2.152', key: '1crzgf' }],
      ['circle', { cx: '12', cy: '12', r: '3', key: '1v7zrd' }],
      ['circle', { cx: '19', cy: '5', r: '2', key: 'mhkx31' }],
      ['circle', { cx: '5', cy: '19', r: '2', key: 'v8kfzx' }],
    ],
    UsersRound: [
      ['path', { d: 'M18 21a8 8 0 0 0-16 0', key: '3ypg7q' }],
      ['circle', { cx: '10', cy: '8', r: '5', key: 'o932ke' }],
      ['path', { d: 'M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3', key: '10s06x' }],
    ],
    Bookmark: [
      [
        'path',
        {
          d: 'M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z',
          key: 'oz39mx',
        },
      ],
    ],
    Search: [
      ['path', { d: 'm21 21-4.34-4.34', key: '14j7rj' }],
      ['circle', { cx: '11', cy: '11', r: '8', key: '4ej97u' }],
    ],
    Share2: [
      ['circle', { cx: '18', cy: '5', r: '3', key: 'gq8acd' }],
      ['circle', { cx: '6', cy: '12', r: '3', key: 'w7nqdw' }],
      ['circle', { cx: '18', cy: '19', r: '3', key: '1xt0gg' }],
      ['line', { x1: '8.59', x2: '15.42', y1: '13.51', y2: '17.49', key: '47mynk' }],
      ['line', { x1: '15.41', x2: '8.59', y1: '6.51', y2: '10.49', key: '1n3mei' }],
    ],
    Send: [
      [
        'path',
        {
          d: 'M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z',
          key: '1ffxy3',
        },
      ],
      ['path', { d: 'm21.854 2.147-10.94 10.939', key: '12cjpa' }],
    ],
    Mail: [
      ['path', { d: 'm22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7', key: '132q7q' }],
      ['rect', { x: '2', y: '4', width: '20', height: '16', rx: '2', key: 'izxlao' }],
    ],
    Sparkles: [
      [
        'path',
        {
          d: 'M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z',
          key: '1s2grr',
        },
      ],
      ['path', { d: 'M20 2v4', key: '1rf3ol' }],
      ['path', { d: 'M22 4h-4', key: 'gwowj6' }],
      ['circle', { cx: '4', cy: '20', r: '2', key: '6kqj1y' }],
    ],
    Gem: [
      ['path', { d: 'M10.5 3 8 9l4 13 4-13-2.5-6', key: 'b3dvk1' }],
      [
        'path',
        {
          d: 'M17 3a2 2 0 0 1 1.6.8l3 4a2 2 0 0 1 .013 2.382l-7.99 10.986a2 2 0 0 1-3.247 0l-7.99-10.986A2 2 0 0 1 2.4 7.8l2.998-3.997A2 2 0 0 1 7 3z',
          key: '7w4byz',
        },
      ],
      ['path', { d: 'M2 9h20', key: '16fsjt' }],
    ],
    Crown: [
      [
        'path',
        {
          d: 'M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z',
          key: '1vdc57',
        },
      ],
      ['path', { d: 'M5 21h14', key: '11awu3' }],
    ],
    ListMusic: [
      ['path', { d: 'M16 5H3', key: 'm91uny' }],
      ['path', { d: 'M11 12H3', key: '51ecnj' }],
      ['path', { d: 'M11 19H3', key: 'zflm78' }],
      ['path', { d: 'M21 16V5', key: 'yxg4q8' }],
      ['circle', { cx: '18', cy: '16', r: '3', key: '1hluhg' }],
    ],
    WandSparkles: [
      [
        'path',
        {
          d: 'm21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72',
          key: 'ul74o6',
        },
      ],
      ['path', { d: 'm14 7 3 3', key: '1r5n42' }],
      ['path', { d: 'M5 6v4', key: 'ilb8ba' }],
      ['path', { d: 'M19 14v4', key: 'blhpug' }],
      ['path', { d: 'M10 2v2', key: '7u0qdc' }],
      ['path', { d: 'M7 8H3', key: 'zfb6yr' }],
      ['path', { d: 'M21 16h-4', key: '1cnmox' }],
      ['path', { d: 'M11 3H9', key: '1obp7u' }],
    ],
    ListChecks: [
      ['path', { d: 'M13 5h8', key: 'a7qcls' }],
      ['path', { d: 'M13 12h8', key: 'h98zly' }],
      ['path', { d: 'M13 19h8', key: 'c3s6r1' }],
      ['path', { d: 'm3 17 2 2 4-4', key: '1jhpwq' }],
      ['path', { d: 'm3 7 2 2 4-4', key: '1obspn' }],
    ],
    Star: [
      [
        'path',
        {
          d: 'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z',
          key: 'r04s7s',
        },
      ],
    ],
    MessageCircle: [
      [
        'path',
        {
          d: 'M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719',
          key: '1sd12s',
        },
      ],
    ],
    UserPlus: [
      ['path', { d: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', key: '1yyitq' }],
      ['circle', { cx: '9', cy: '7', r: '4', key: 'nufk8' }],
      ['line', { x1: '19', x2: '19', y1: '8', y2: '14', key: '1bvyxn' }],
      ['line', { x1: '22', x2: '16', y1: '11', y2: '11', key: '1shjgl' }],
    ],
    Heart: [
      [
        'path',
        {
          d: 'M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5',
          key: 'mvr1a0',
        },
      ],
    ],
    MessageCircleMore: [
      [
        'path',
        {
          d: 'M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719',
          key: '1sd12s',
        },
      ],
      ['path', { d: 'M8 12h.01', key: 'czm47f' }],
      ['path', { d: 'M12 12h.01', key: '1mp3jc' }],
      ['path', { d: 'M16 12h.01', key: '1l6xoz' }],
    ],
    Flame: [
      [
        'path',
        {
          d: 'M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4',
          key: '1slcih',
        },
      ],
    ],
    CalendarClock: [
      ['path', { d: 'M16 14v2.2l1.6 1', key: 'fo4ql5' }],
      ['path', { d: 'M16 2v4', key: '4m81vk' }],
      [
        'path',
        { d: 'M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5', key: '1osxxc' },
      ],
      ['path', { d: 'M3 10h5', key: 'r794hk' }],
      ['path', { d: 'M8 2v4', key: '1cmpym' }],
      ['circle', { cx: '16', cy: '16', r: '6', key: 'qoo3c4' }],
    ],
    BadgeCheck: [
      [
        'path',
        {
          d: 'M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z',
          key: '3c2336',
        },
      ],
      ['path', { d: 'm9 12 2 2 4-4', key: 'dzmm74' }],
    ],
    Award: [
      [
        'path',
        {
          d: 'm15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526',
          key: '1yiouv',
        },
      ],
      ['circle', { cx: '12', cy: '8', r: '6', key: '1vp47v' }],
    ],
    CalendarRange: [
      ['rect', { width: '18', height: '18', x: '3', y: '4', rx: '2', key: '1hopcy' }],
      ['path', { d: 'M16 2v4', key: '4m81vk' }],
      ['path', { d: 'M3 10h18', key: '8toen8' }],
      ['path', { d: 'M8 2v4', key: '1cmpym' }],
      ['path', { d: 'M17 14h-6', key: 'bkmgh3' }],
      ['path', { d: 'M13 18H7', key: 'bb0bb7' }],
      ['path', { d: 'M7 14h.01', key: '1qa3f1' }],
      ['path', { d: 'M17 18h.01', key: '1bdyru' }],
    ],
    Medal: [
      [
        'path',
        {
          d: 'M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15',
          key: '143lza',
        },
      ],
      ['path', { d: 'M11 12 5.12 2.2', key: 'qhuxz6' }],
      ['path', { d: 'm13 12 5.88-9.8', key: 'hbye0f' }],
      ['path', { d: 'M8 7h8', key: 'i86dvs' }],
      ['circle', { cx: '12', cy: '17', r: '5', key: 'qbz8iq' }],
      ['path', { d: 'M12 18v-2h-.5', key: 'fawc4q' }],
    ],
    Footprints: [
      [
        'path',
        {
          d: 'M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z',
          key: '1dudjm',
        },
      ],
      [
        'path',
        {
          d: 'M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z',
          key: 'l2t8xc',
        },
      ],
      ['path', { d: 'M16 17h4', key: '1dejxt' }],
      ['path', { d: 'M4 13h4', key: '1bwh8b' }],
    ],
    MessagesSquare: [
      [
        'path',
        {
          d: 'M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z',
          key: '1n2ejm',
        },
      ],
      [
        'path',
        {
          d: 'M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1',
          key: '1qfcsi',
        },
      ],
    ],
  },
  path: 'M 224 4.599 C 190.371 8.351, 165.289 15.443, 137.500 29.058 C 67.631 63.289, 22.642 123.911, 7.675 204 L 5.526 215.500 5.250 438.882 L 4.974 662.263 7.544 667.882 C 10.585 674.532, 13.873 678.217, 20 681.839 L 24.500 684.500 100 684.500 L 175.500 684.500 180.247 681.710 C 186.456 678.060, 189.499 674.754, 193.071 667.779 L 196 662.057 196.012 452.779 C 196.022 281.376, 196.265 242.595, 197.360 238.500 C 208.432 197.057, 260.397 188.580, 281.598 224.757 C 297.832 252.459, 276.355 291, 244.685 291 C 234.694 291, 228.577 294.594, 226.136 301.899 C 224.187 307.731, 224.562 463.507, 226.539 469.110 C 230.396 480.044, 236.428 482.510, 257.269 481.676 C 340.681 478.338, 413.188 430.472, 454.458 351.500 C 456.470 347.650, 458.717 342.925, 459.451 341 C 460.185 339.075, 462.222 333.900, 463.977 329.500 C 478.236 293.750, 483.703 249.362, 478.570 211 C 464.019 102.243, 387.429 23.683, 279.500 6.811 C 267.184 4.886, 233.471 3.542, 224 4.599 Z M57.75 204.45 L55.31 200.87 L55.25 197.75 L55.46 194.67 L55.83 191.62 L56.32 188.59 L56.90 185.57 L57.56 182.57 L58.29 179.58 L59.10 176.61 L59.96 173.66 L60.89 170.72 L61.88 167.80 L62.93 164.90 L64.03 162.02 L65.19 159.16 L66.40 156.31 L67.66 153.49 L68.98 150.69 L70.34 147.92 L71.76 145.17 L73.22 142.44 L74.74 139.74 L76.30 137.06 L77.91 134.41 L79.57 131.79 L81.27 129.20 L83.02 126.64 L84.81 124.11 L86.64 121.61 L88.52 119.14 L90.44 116.70 L92.41 114.30 L94.41 111.93 L96.46 109.59 L98.55 107.30 L100.67 105.03 L102.84 102.81 L105.04 100.62 L107.28 98.47 L109.55 96.36 L111.86 94.29 L114.21 92.26 L116.59 90.27 L119.01 88.32 L121.46 86.41 L123.94 84.55 L126.45 82.73 L128.99 80.96 L131.56 79.23 L134.16 77.55 L136.80 75.92 L139.45 74.33 L142.14 72.79 L144.85 71.30 L147.58 69.86 L150.34 68.47 L153.13 67.13 L155.94 65.84 L158.77 64.61 L161.62 63.43 L164.49 62.31 L167.38 61.25 L170.29 60.25 L173.22 59.32 L176.17 58.45 L179.14 57.65 L182.13 56.94 L185.14 56.31 L188.17 55.80 L191.23 55.45 L194.35 55.37 L198.03 57.64 L198.03 57.64 L195.96 61.41 L193.34 62.90 L190.69 64.21 L188.03 65.45 L185.38 66.67 L182.74 67.89 L180.11 69.11 L177.50 70.35 L174.90 71.60 L172.31 72.88 L169.74 74.19 L167.19 75.52 L164.66 76.88 L162.15 78.26 L159.65 79.68 L157.18 81.13 L154.72 82.60 L152.29 84.11 L149.88 85.65 L147.49 87.22 L145.12 88.82 L142.78 90.45 L140.46 92.11 L138.16 93.80 L135.89 95.53 L133.64 97.28 L131.42 99.06 L129.22 100.88 L127.05 102.72 L124.90 104.59 L122.78 106.49 L120.69 108.42 L118.63 110.38 L116.59 112.37 L114.58 114.39 L112.60 116.43 L110.65 118.50 L108.73 120.60 L106.83 122.73 L104.97 124.88 L103.13 127.06 L101.33 129.26 L99.56 131.49 L97.81 133.74 L96.10 136.02 L94.42 138.32 L92.77 140.65 L91.15 142.99 L89.57 145.36 L88.01 147.76 L86.49 150.17 L85.00 152.61 L83.54 155.07 L82.11 157.55 L80.72 160.05 L79.35 162.56 L78.02 165.10 L76.72 167.66 L75.45 170.23 L74.21 172.82 L72.99 175.43 L71.81 178.06 L70.65 180.70 L69.51 183.35 L68.39 186.02 L67.29 188.70 L66.19 191.40 L65.10 194.10 L63.97 196.81 L62.79 199.52 L61.41 202.20 L57.75 204.45 Z M101.66 214.33 L99.64 211.62 L99.45 209.23 L99.50 206.89 L99.69 204.56 L99.97 202.24 L100.33 199.94 L100.75 197.65 L101.24 195.37 L101.78 193.10 L102.37 190.84 L103.02 188.59 L103.71 186.36 L104.44 184.14 L105.23 181.93 L106.05 179.74 L106.92 177.56 L107.83 175.40 L108.79 173.25 L109.78 171.12 L110.81 169.01 L111.88 166.92 L112.99 164.85 L114.14 162.79 L115.32 160.76 L116.54 158.74 L117.80 156.75 L119.09 154.78 L120.42 152.84 L121.78 150.91 L123.18 149.01 L124.61 147.14 L126.08 145.29 L127.57 143.47 L129.10 141.67 L130.66 139.90 L132.25 138.16 L133.87 136.44 L135.52 134.76 L137.20 133.10 L138.91 131.48 L140.65 129.88 L142.41 128.32 L144.21 126.78 L146.02 125.28 L147.87 123.82 L149.74 122.38 L151.63 120.98 L153.55 119.62 L155.49 118.29 L157.46 116.99 L159.45 115.73 L161.45 114.51 L163.48 113.33 L165.54 112.18 L167.61 111.08 L169.69 110.01 L171.80 108.98 L173.93 108.00 L176.07 107.06 L178.23 106.16 L180.41 105.31 L182.60 104.50 L184.81 103.74 L187.04 103.04 L189.28 102.38 L191.53 101.79 L193.80 101.27 L196.09 100.82 L198.40 100.46 L200.74 100.24 L203.12 100.25 L205.98 102.07 L205.98 102.07 L204.52 105.10 L202.61 106.39 L200.67 107.51 L198.72 108.56 L196.77 109.59 L194.83 110.60 L192.90 111.62 L190.97 112.63 L189.06 113.66 L187.16 114.70 L185.27 115.75 L183.40 116.82 L181.54 117.91 L179.69 119.01 L177.86 120.14 L176.04 121.28 L174.24 122.45 L172.45 123.63 L170.68 124.83 L168.93 126.06 L167.19 127.30 L165.47 128.57 L163.77 129.86 L162.09 131.16 L160.42 132.49 L158.77 133.84 L157.14 135.21 L155.52 136.60 L153.93 138.01 L152.35 139.44 L150.80 140.89 L149.26 142.36 L147.74 143.85 L146.25 145.36 L144.77 146.89 L143.31 148.43 L141.88 150.00 L140.46 151.59 L139.06 153.19 L137.69 154.81 L136.34 156.45 L135.00 158.11 L133.69 159.79 L132.40 161.48 L131.14 163.19 L129.89 164.92 L128.66 166.66 L127.46 168.42 L126.28 170.20 L125.12 171.99 L123.99 173.80 L122.87 175.62 L121.78 177.46 L120.71 179.32 L119.66 181.18 L118.63 183.06 L117.62 184.96 L116.63 186.87 L115.67 188.79 L114.72 190.73 L113.79 192.68 L112.88 194.63 L111.98 196.61 L111.10 198.59 L110.22 200.58 L109.35 202.58 L108.49 204.60 L107.61 206.61 L106.70 208.64 L105.72 210.65 L104.58 212.65 L101.66 214.33 Z M145.61 224.12 L144.39 222.31 L144.13 220.66 L144.03 219.03 L144.04 217.41 L144.12 215.79 L144.26 214.18 L144.45 212.58 L144.68 210.98 L144.96 209.39 L145.28 207.81 L145.64 206.23 L146.04 204.66 L146.47 203.09 L146.94 201.54 L147.43 200.00 L147.97 198.46 L148.53 196.93 L149.13 195.42 L149.75 193.91 L150.41 192.42 L151.10 190.94 L151.81 189.48 L152.56 188.02 L153.33 186.58 L154.13 185.16 L154.96 183.75 L155.82 182.36 L156.71 180.98 L157.62 179.62 L158.56 178.27 L159.52 176.95 L160.51 175.64 L161.52 174.35 L162.56 173.08 L163.62 171.83 L164.71 170.60 L165.82 169.40 L166.95 168.21 L168.10 167.04 L169.28 165.90 L170.47 164.78 L171.69 163.69 L172.93 162.61 L174.19 161.56 L175.47 160.54 L176.76 159.54 L178.08 158.57 L179.41 157.62 L180.76 156.70 L182.13 155.81 L183.51 154.94 L184.91 154.10 L186.33 153.29 L187.76 152.51 L189.20 151.76 L190.66 151.04 L192.13 150.35 L193.62 149.70 L195.11 149.07 L196.62 148.48 L198.14 147.92 L199.67 147.40 L201.22 146.92 L202.77 146.47 L204.33 146.07 L205.91 145.71 L207.49 145.40 L209.09 145.16 L210.70 144.98 L212.34 144.90 L214.01 144.99 L215.93 146.02 L215.93 146.02 L214.92 147.93 L213.66 148.95 L212.37 149.85 L211.09 150.69 L209.80 151.51 L208.52 152.31 L207.25 153.11 L205.98 153.90 L204.72 154.70 L203.47 155.49 L202.23 156.30 L200.99 157.11 L199.77 157.93 L198.56 158.75 L197.36 159.59 L196.17 160.43 L194.99 161.29 L193.82 162.15 L192.66 163.03 L191.51 163.92 L190.37 164.81 L189.24 165.72 L188.13 166.64 L187.02 167.57 L185.93 168.51 L184.85 169.46 L183.78 170.42 L182.72 171.39 L181.67 172.38 L180.63 173.37 L179.61 174.38 L178.60 175.39 L177.60 176.42 L176.61 177.46 L175.63 178.51 L174.66 179.57 L173.71 180.64 L172.77 181.72 L171.84 182.81 L170.92 183.92 L170.02 185.03 L169.12 186.16 L168.24 187.29 L167.37 188.43 L166.52 189.59 L165.67 190.75 L164.84 191.93 L164.02 193.12 L163.21 194.31 L162.41 195.52 L161.63 196.73 L160.86 197.96 L160.10 199.19 L159.35 200.44 L158.61 201.69 L157.88 202.95 L157.17 204.23 L156.46 205.51 L155.76 206.80 L155.08 208.10 L154.40 209.41 L153.73 210.73 L153.07 212.06 L152.41 213.39 L151.75 214.74 L151.10 216.09 L150.43 217.45 L149.75 218.81 L149.05 220.18 L148.29 221.55 L147.41 222.91 L145.61 224.12 Z M433.10 307.11 L435.09 310.82 L434.80 313.76 L434.25 316.62 L433.56 319.44 L432.76 322.23 L431.88 324.99 L430.93 327.73 L429.91 330.45 L428.83 333.15 L427.70 335.83 L426.52 338.48 L425.29 341.12 L424.01 343.73 L422.68 346.32 L421.30 348.89 L419.89 351.43 L418.42 353.95 L416.92 356.45 L415.37 358.93 L413.78 361.38 L412.16 363.80 L410.49 366.20 L408.78 368.57 L407.03 370.91 L405.25 373.23 L403.43 375.52 L401.57 377.77 L399.68 380.00 L397.75 382.20 L395.79 384.37 L393.79 386.51 L391.76 388.62 L389.70 390.70 L387.60 392.74 L385.47 394.75 L383.31 396.72 L381.12 398.66 L378.90 400.57 L376.65 402.44 L374.37 404.28 L372.06 406.08 L369.73 407.84 L367.37 409.57 L364.98 411.25 L362.56 412.90 L360.12 414.51 L357.65 416.09 L355.16 417.62 L352.65 419.11 L350.11 420.56 L347.55 421.97 L344.97 423.33 L342.37 424.65 L339.75 425.93 L337.11 427.17 L334.45 428.36 L331.77 429.51 L329.07 430.60 L326.35 431.65 L323.62 432.66 L320.87 433.61 L318.11 434.51 L315.33 435.35 L312.54 436.14 L309.73 436.86 L306.90 437.52 L304.06 438.11 L301.20 438.61 L298.33 439.01 L295.42 439.26 L292.47 439.24 L288.99 436.87 L288.99 436.87 L290.98 433.21 L293.48 431.81 L296.01 430.60 L298.54 429.46 L301.07 428.35 L303.60 427.26 L306.11 426.16 L308.62 425.05 L311.12 423.93 L313.60 422.79 L316.07 421.63 L318.52 420.45 L320.97 419.25 L323.39 418.02 L325.81 416.77 L328.20 415.50 L330.58 414.20 L332.95 412.87 L335.30 411.52 L337.63 410.14 L339.94 408.74 L342.24 407.30 L344.52 405.85 L346.77 404.36 L349.01 402.85 L351.24 401.32 L353.44 399.76 L355.62 398.17 L357.78 396.55 L359.93 394.91 L362.05 393.25 L364.15 391.55 L366.23 389.84 L368.29 388.09 L370.32 386.33 L372.34 384.54 L374.33 382.72 L376.30 380.88 L378.25 379.01 L380.18 377.12 L382.08 375.21 L383.96 373.27 L385.81 371.32 L387.64 369.33 L389.45 367.33 L391.24 365.30 L393.00 363.25 L394.73 361.18 L396.44 359.09 L398.13 356.98 L399.79 354.84 L401.43 352.69 L403.05 350.52 L404.64 348.32 L406.20 346.11 L407.74 343.88 L409.26 341.63 L410.76 339.36 L412.23 337.07 L413.68 334.77 L415.11 332.45 L416.52 330.12 L417.91 327.76 L419.29 325.40 L420.66 323.02 L422.01 320.64 L423.37 318.24 L424.73 315.84 L426.13 313.44 L427.60 311.05 L429.25 308.71 L433.10 307.11 Z M388.51 298.05 L390.05 300.92 L389.88 303.14 L389.49 305.28 L388.97 307.39 L388.37 309.47 L387.71 311.52 L386.99 313.56 L386.21 315.58 L385.39 317.58 L384.53 319.56 L383.63 321.52 L382.68 323.47 L381.70 325.41 L380.69 327.32 L379.64 329.22 L378.56 331.10 L377.44 332.96 L376.29 334.80 L375.11 336.63 L373.90 338.44 L372.66 340.22 L371.39 341.99 L370.09 343.74 L368.77 345.46 L367.41 347.17 L366.03 348.85 L364.62 350.51 L363.18 352.15 L361.72 353.77 L360.23 355.36 L358.72 356.93 L357.18 358.48 L355.62 360.00 L354.03 361.50 L352.42 362.97 L350.79 364.42 L349.14 365.84 L347.46 367.23 L345.76 368.60 L344.04 369.94 L342.30 371.26 L340.54 372.54 L338.76 373.80 L336.96 375.03 L335.14 376.23 L333.30 377.40 L331.44 378.54 L329.57 379.65 L327.68 380.74 L325.77 381.79 L323.85 382.80 L321.91 383.79 L319.96 384.74 L317.99 385.66 L316.01 386.55 L314.01 387.40 L312.00 388.22 L309.98 389.00 L307.95 389.75 L305.90 390.46 L303.84 391.13 L301.77 391.75 L299.69 392.34 L297.59 392.88 L295.49 393.37 L293.38 393.81 L291.25 394.19 L289.11 394.51 L286.95 394.73 L284.77 394.83 L282.55 394.70 L279.92 392.78 L279.92 392.78 L281.33 389.87 L283.14 388.70 L284.98 387.69 L286.82 386.76 L288.66 385.87 L290.50 384.99 L292.34 384.11 L294.17 383.24 L295.99 382.36 L297.80 381.47 L299.61 380.58 L301.40 379.67 L303.18 378.75 L304.96 377.81 L306.72 376.87 L308.48 375.90 L310.22 374.93 L311.95 373.93 L313.67 372.92 L315.38 371.89 L317.07 370.85 L318.76 369.79 L320.43 368.72 L322.09 367.62 L323.74 366.51 L325.37 365.38 L327.00 364.24 L328.61 363.08 L330.20 361.90 L331.79 360.71 L333.35 359.50 L334.91 358.27 L336.45 357.02 L337.98 355.76 L339.50 354.48 L341.00 353.19 L342.48 351.88 L343.95 350.55 L345.41 349.21 L346.85 347.85 L348.28 346.47 L349.69 345.08 L351.09 343.68 L352.48 342.26 L353.85 340.82 L355.20 339.37 L356.54 337.90 L357.86 336.42 L359.17 334.92 L360.46 333.41 L361.74 331.88 L363.01 330.35 L364.25 328.79 L365.49 327.23 L366.71 325.65 L367.91 324.05 L369.11 322.45 L370.28 320.83 L371.45 319.20 L372.60 317.55 L373.75 315.90 L374.88 314.23 L376.00 312.56 L377.12 310.87 L378.24 309.18 L379.35 307.48 L380.47 305.78 L381.61 304.07 L382.79 302.37 L384.03 300.69 L385.44 299.06 L388.51 298.05 Z M345.18 285.16 L346.01 287.07 L345.92 288.60 L345.68 290.07 L345.35 291.52 L344.96 292.94 L344.52 294.35 L344.05 295.74 L343.53 297.12 L342.98 298.49 L342.40 299.84 L341.79 301.18 L341.16 302.51 L340.49 303.83 L339.80 305.14 L339.09 306.43 L338.35 307.71 L337.59 308.98 L336.81 310.24 L336.00 311.48 L335.18 312.71 L334.33 313.92 L333.46 315.13 L332.57 316.31 L331.66 317.49 L330.73 318.64 L329.78 319.79 L328.81 320.91 L327.82 322.02 L326.82 323.12 L325.79 324.20 L324.75 325.26 L323.69 326.30 L322.62 327.33 L321.52 328.34 L320.42 329.34 L319.29 330.31 L318.15 331.27 L317.00 332.20 L315.83 333.12 L314.64 334.02 L313.44 334.90 L312.23 335.76 L311.00 336.60 L309.76 337.42 L308.51 338.22 L307.24 339.00 L305.96 339.76 L304.67 340.49 L303.37 341.21 L302.06 341.90 L300.73 342.57 L299.40 343.21 L298.05 343.83 L296.70 344.43 L295.34 345.01 L293.96 345.56 L292.58 346.08 L291.19 346.58 L289.79 347.06 L288.39 347.50 L286.97 347.92 L285.55 348.31 L284.12 348.67 L282.68 348.99 L281.24 349.29 L279.79 349.54 L278.33 349.75 L276.86 349.91 L275.39 350.00 L273.89 350.01 L272.37 349.86 L270.61 348.73 L270.61 348.73 L271.59 346.91 L272.79 346.02 L274.01 345.26 L275.23 344.55 L276.46 343.87 L277.68 343.20 L278.90 342.55 L280.12 341.90 L281.33 341.25 L282.53 340.60 L283.73 339.94 L284.93 339.28 L286.11 338.62 L287.29 337.95 L288.47 337.27 L289.63 336.59 L290.79 335.89 L291.95 335.19 L293.09 334.49 L294.23 333.77 L295.36 333.05 L296.49 332.31 L297.60 331.57 L298.71 330.82 L299.82 330.06 L300.91 329.29 L302.00 328.52 L303.08 327.73 L304.15 326.93 L305.22 326.13 L306.27 325.31 L307.32 324.49 L308.36 323.66 L309.40 322.81 L310.42 321.96 L311.44 321.10 L312.45 320.23 L313.45 319.36 L314.45 318.47 L315.44 317.57 L316.42 316.67 L317.39 315.75 L318.35 314.83 L319.31 313.89 L320.25 312.95 L321.19 312.00 L322.13 311.04 L323.05 310.07 L323.97 309.10 L324.88 308.11 L325.78 307.12 L326.67 306.11 L327.56 305.10 L328.44 304.08 L329.31 303.06 L330.18 302.02 L331.04 300.98 L331.89 299.92 L332.74 298.86 L333.58 297.80 L334.42 296.72 L335.26 295.64 L336.09 294.56 L336.93 293.46 L337.76 292.37 L338.60 291.26 L339.45 290.16 L340.32 289.06 L341.21 287.96 L342.16 286.88 L343.22 285.83 L345.18 285.16 Z',
  names: {
    goal_first: { ko: '첫 목표', en: 'First Goal' },
    goal_three_months: { ko: '세 달의 리듬', en: 'Three Months in Rhythm' },
    goal_week_streak_4: { ko: '네 번의 약속', en: 'Four Promises Kept' },
    goal_six_months: { ko: '반년의 약속', en: 'A Six-Month Promise' },
    goal_week_streak_12: { ko: '계절의 리듬', en: 'A Season in Rhythm' },
    ratings_10: { ko: '첫 열 장', en: 'The First Ten' },
    reviews_first: { ko: '첫 감상', en: 'First Impression' },
    reviews_25: { ko: '리뷰 노트', en: 'Review Notes' },
    ratings_50: { ko: '쉰 장의 기억', en: 'Fifty Albums Remembered' },
    ratings_100: { ko: '백 장의 귀', en: 'An Ear for a Hundred' },
    reviews_50: { ko: '오십 편의 기록', en: 'Fifty Reviews on Record' },
    track_ratings_25: { ko: '곡을 듣는 귀', en: 'An Ear for Tracks' },
    decades_5: { ko: '시간 여행자', en: 'Time Traveler' },
    genres_10: { ko: '장르 탐험가', en: 'Genre Explorer' },
    decades_8: { ko: '세기의 산책자', en: 'Across Eight Decades' },
    genres_20: { ko: '경계 없는 귀', en: 'Ears Without Borders' },
    members_explored_10: { ko: '취향의 이웃', en: 'Taste Neighbors' },
    members_explored_30: { ko: '취향의 골목', en: 'A Lane of Tastes' },
    members_explored_100: { ko: '백 개의 취향 지도', en: 'A Map of One Hundred Tastes' },
    saves_10: { ko: '다시 들을 목록', en: 'Saved for Later' },
    saves_50: { ko: '나만의 음악 서가', en: 'My Music Shelf' },
    discoveries_25: { ko: '스물다섯 번의 발견', en: 'Twenty-Five Discoveries' },
    discoveries_100: { ko: '백 번의 발견', en: 'One Hundred Discoveries' },
    shares_first: { ko: '첫 번째 건넴', en: 'The First Share' },
    shares_3: { ko: '취향을 건네는 사람', en: 'Passing It On' },
    shares_20: { ko: '스무 번의 음악 편지', en: 'Twenty Music Letters' },
    mastery_1: { ko: '취향의 설계자', en: 'Taste Architect' },
    mastery_2: { ko: '음악 생활의 장인', en: 'Music Life Artisan' },
    mastery_3: { ko: '포스트팝 마스터', en: 'Postpop Master' },
    playlist_5: { ko: '첫 큐레이션', en: 'First Curation' },
    curator_3: { ko: '큐레이터', en: 'Curator' },
    playlist_20: { ko: '긴 호흡의 셀렉션', en: 'The Long Selection' },
    curator_10: { ko: '열 개의 진열장', en: 'Ten Curated Collections' },
    community_days_5: { ko: '대화의 시작', en: 'The Conversation Begins' },
    community_days_3: { ko: '대화의 시작', en: 'The Conversation Begins' },
    following_5: { ko: '다섯 취향의 연결', en: 'Five Taste Connections' },
    following_20: { ko: '스무 취향의 연결', en: 'Twenty Taste Connections' },
    reactions_10: { ko: '공감받는 기록', en: 'A Record That Resonates' },
    community_days_30: { ko: '서른 날의 대화', en: 'Thirty Days of Conversation' },
    reactions_50: { ko: '쉰 사람의 공감', en: 'Fifty Listeners in Tune' },
    reactions_25: { ko: '스물다섯 사람의 공감', en: 'Twenty-Five Listeners in Tune' },
    streak_3: { ko: '3일의 리듬', en: 'Three Days in Rhythm' },
    streak_7: { ko: '일주일의 리듬', en: 'A Week in Rhythm' },
    streak_14: { ko: '보름의 리듬', en: 'Two Weeks in Rhythm' },
    streak_30: { ko: '한 달의 루틴', en: 'A Month in Motion' },
    active_weeks_4: { ko: '네 주의 음악 생활', en: 'Four Weeks of Music' },
    active_weeks_12: { ko: '한 계절의 음악 생활', en: 'A Season of Music' },
    badges_5: { ko: '수집의 시작', en: 'The Collection Begins' },
    badges_15: { ko: '배지 선반', en: 'The Badge Shelf' },
    badges_25: { ko: '컬렉션 마스터', en: 'Collection Master' },
    season_participant: { ko: '시즌 참가자', en: 'Season Participant' },
    hidden_pathfinder: { ko: '숨은 배지', en: 'Hidden Badge' },
  },
};
